import { render } from "./GrcHome.vue?vue&type=template&id=04230954&scoped=true"
import script from "./GrcHome.vue?vue&type=script&setup=true&lang=js"
export * from "./GrcHome.vue?vue&type=script&setup=true&lang=js"

import "./GrcHome.vue?vue&type=style&index=0&id=04230954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04230954"],['__file',"src/views/grc/GrcHome.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04230954"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04230954', __exports__)) {
    api.reload('04230954', __exports__)
  }
  
  module.hot.accept("./GrcHome.vue?vue&type=template&id=04230954&scoped=true", () => {
    api.rerender('04230954', render)
  })

}


export default __exports__